<template>
  <div class="w-100 table-responsive">
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-default">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col cols="12">
          <b-card class="table-responsive">
            <b-card-header class="border-0">
              <h3 class="mb-0">Listado de tickets</h3>
            </b-card-header>
            <b-table small hover :items="arrayTickets" :fields="columns">
              <template #cell(user)="{item}">
                {{ item.user.name }} - {{ item.user.email }}
              </template>
              <template #cell(created_at)="{item}">
                {{ item.created_at |formatDate }}
              </template>
              <template #cell(isSolved)="{item}">
                {{ item.isSolved ? "SI": "NO" }}
              </template>
              <template #cell(actions)="{item}">
                <button class="btn btn-sm btn-outline-primary" @click="view(item._id)">
                  <i class="ni ni-bold-right"></i>
                </button>
              </template>
            </b-table>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {get} from "@/util/axiosRequest";

export default {
  name: "Support",
  data: () => ({
    arrayTickets: [],
    columns: [
      {key: "user", label:"Usuario", sortable: true},
      {key: "subject", label:"Asunto", sortable: true},
      {key: "isSolved", label:"Solucionado", sortable: true},
      {key: "created_at", label:"Fecha", sortable: true},
      {key: "actions", label:"", sortable: true},
    ],
  }),
  mounted() {
    this.getTickets()
  },
  methods: {
    async getTickets() {
      const {data} = await get("support", null, true)
      this.arrayTickets = data
    },
    view(id){
        this.$router.push({name: "support-detail", query: {id: id}})
    }
  }
}
</script>

<style scoped>

</style>
